import { FormElementModel } from "./FormElementModel";
import {
  emailValidator,
  nipValidator,
  phoneValidator,
  repeatEmailValidator,
  onlyTextValidator,
  zipCodeValidator,
  specialCharacterValidator,
  lastNameValidator
} from "../../utils/formsValidation";
import { UseFormRegister } from "react-hook-form";

export interface InputsFinalize {
  firstName: string;
  lastName: string;
  email: string;
  repeatEmail: string;
  phone: string;
  city: string;
  street: string;
  houseNumber: string;
  flatNumber: string;
  zipCode: string;
  NIP: string;
  companyName: string;
  createUser: boolean;
  createInvoice: boolean;
  acceptEAktywni: boolean;
  acceptPrivacyPolicy: boolean;
  acceptStatute: boolean;
}

export const initialInputsFinalize = {
  firstName: "",
  lastName: "",
  email: "",
  repeatEmail: "",
  phone: "",
  acceptStatute: false,
  acceptPrivacyPolicy: false
} as InputsFinalize;

export const userPayForm = (
  watch: any,
  register: UseFormRegister<InputsFinalize>,
  isCompanyInvoice: boolean,
  isInvoice: boolean,
  isRealizeVoucher: boolean
): FormElementModel[] => [
  {
    name: "firstName",
    type: "text",
    text: "Imię *",
    isLabel: false,
    register: { ...register("firstName", { ...onlyTextValidator(true) }) }
  },
  {
    name: "lastName",
    type: "text",
    text: "Nazwisko *",
    isLabel: false,
    register: { ...register("lastName", { ...lastNameValidator(true) }) }
  },
  {
    name: "email",
    type: "text",
    text: "E-mail *",
    isLabel: false,
    register: { ...register("email", { ...emailValidator(true) }) }
  },
  {
    name: "repeatEmail",
    type: "text",
    text: "Powtórz e-mail *",
    isLabel: false,
    register: { ...register("repeatEmail", { ...repeatEmailValidator(true, watch("email", "")) }) }
  },
  isRealizeVoucher
    ? {
        name: "zipCode",
        type: "text",
        text: "Kod pocztowy",
        isLabel: false,
        register: { ...register("zipCode", { ...zipCodeValidator(false) }) }
      }
    : ({} as FormElementModel),
  {
    name: "phone",
    type: "text",
    text: "Numer telefonu",
    isLabel: false,
    register: { ...register("phone", { ...phoneValidator(false) }) }
  },
  isCompanyInvoice
    ? {
        name: "companyName",
        type: "text",
        text: "Nazwa firmy *",
        isLabel: false,
        register: { ...register("companyName", { ...specialCharacterValidator(true) }) }
      }
    : ({} as FormElementModel),
  isCompanyInvoice
    ? {
        name: "NIP",
        type: "text",
        text: "NIP *",
        isLabel: false,
        register: { ...register("NIP", { ...nipValidator(true) }) }
      }
    : ({} as FormElementModel),
  isInvoice
    ? {
        name: "street",
        type: "text",
        text: "Ulica *",
        isLabel: false,
        register: { ...register("street", { ...onlyTextValidator(true) }) }
      }
    : ({} as FormElementModel),
  isInvoice
    ? {
        name: "houseNumber",
        type: "text",
        text: "Numer domu *",
        isLabel: false,
        register: { ...register("houseNumber", { ...specialCharacterValidator(true) }) }
      }
    : ({} as FormElementModel),
  isInvoice
    ? {
        name: "flatNumber",
        type: "text",
        text: "Numer mieszkania",
        isLabel: false,
        register: { ...register("flatNumber", { ...specialCharacterValidator(false) }) }
      }
    : ({} as FormElementModel),
  isInvoice
    ? {
        name: "city",
        type: "text",
        text: "Miejscowość *",
        isLabel: false,
        register: { ...register("city", { ...onlyTextValidator(true) }) }
      }
    : ({} as FormElementModel)
];

export const invoiceForm = (register: any, isCompanyInvoice: boolean): FormElementModel[] => [
  isCompanyInvoice
    ? {
        name: "companyName",
        type: "text",
        text: "Nazwa firmy *",
        isLabel: false,
        register: { ...register("companyName", { ...specialCharacterValidator(true) }) }
      }
    : ({} as FormElementModel),
  isCompanyInvoice
    ? {
        name: "NIP",
        type: "text",
        text: "NIP *",
        isLabel: false,
        register: { ...register("NIP", { ...nipValidator(true) }) }
      }
    : ({} as FormElementModel),
  {
    name: "street",
    type: "text",
    text: "Ulica *",
    isLabel: false,
    register: { ...register("street", { ...onlyTextValidator(true) }) }
  },
  {
    name: "houseNumber",
    type: "text",
    text: "Numer domu *",
    isLabel: false,
    register: { ...register("houseNumber", { ...specialCharacterValidator(true) }) }
  },
  {
    name: "flatNumber",
    type: "text",
    text: "Numer mieszkania *",
    isLabel: false,
    register: { ...register("flatNumber", { ...specialCharacterValidator(true) }) }
  },

  {
    name: "city",
    type: "text",
    text: "Miejscowość *",
    isLabel: false,
    register: { ...register("city", { ...onlyTextValidator(true) }) }
  }
];
